import React, { StrictMode } from "react";
import { Generation } from "@App/types";
import { formatDate } from "@App/utils/dates";

type GenerationListItemProps = {
  generation: Generation;
  onClick: (generation: Generation) => void;
};

export const GenerationListItem = React.memo<GenerationListItemProps>(
  ({ generation, onClick }: GenerationListItemProps) => {
    return (
      <StrictMode>
        <div
          className="w-full p-3 border-b border-neutral-100 cursor-pointer"
          onClick={() => onClick(generation)}
        >
          <span className="text-neutral-700 font-bold">{generation.name.split(" (")[0]}</span>
          {generation.built_from && (
            <span className="text-neutral-700">
              {" "}
              - ab {formatDate(generation.built_from, "yyyy")}
            </span>
          )}
        </div>
      </StrictMode>
    );
  },
);
